import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCompany = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M0 1.556C0 .696.696 0 1.556 0h4.666c.86 0 1.556.696 1.556 1.556V3.11H14c.86 0 1.556.696 1.556 1.556v7.777c0 .86-.697 1.556-1.556 1.556H1.556A1.554 1.554 0 0 1 0 12.444V1.556Zm3.111 0H1.556V3.11H3.11V1.556Zm1.556 0h1.555V3.11H4.667V1.556ZM3.11 4.666H1.556v1.556H3.11V4.667Zm1.556 0h1.555v1.556H4.667V4.667Zm9.333 0H7.778v1.556h1.555v1.556H7.778v1.555h1.555v1.556H7.778v1.555H14V4.667Zm-3.111 1.556v1.556h1.555V6.222H10.89ZM3.11 7.778H1.556v1.555H3.11V7.778Zm1.556 0h1.555v1.555H4.667V7.778Zm6.222 3.11V9.334h1.555v1.556H10.89Zm-9.333 0H3.11v1.556H1.556V10.89Zm4.666 0H4.667v1.556h1.555V10.89Z",
		fill: "var(--main-color)"
	})
});
export { SvgCompany as ReactComponent };
